import React, {Component} from 'react';

class PaginateComponent extends Component {

    paginate = () => {
        let page = 0;
        let paginate = [];
        if ( this.props.total % this.props.perPage ) {
            page = parseInt(this.props.total/this.props.perPage + 1);
        } else {
            page = parseInt(this.props.total/this.props.perPage);
        }
        if ( page > 11 ) {
            if ( this.props.currentPage < 7 ) {
                for(let i = 1; i <= 7; i++){
                    if ( this.props.currentPage === i ) {
                        paginate.push(
                            <li className="page-item active disabled" key={ "page" + i }>
                                <button type="button" className="page-link" disabled={true}>{ i }</button>
                            </li>
                        );
                    } else {
                        paginate.push(
                            <li className="page-item" key={ "page" + i }>
                                <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( i ) }>{ i }</button>
                            </li>
                        );
                    }
                }
                paginate.push(
                    <li className="page-item disabled">
                        <span className="page-link">...</span>
                    </li>
                );
                paginate.push(
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( page-1 ) }>{page-1}</button>
                    </li>
                );
                paginate.push(
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( page ) }>{page}</button>
                    </li>
                );
            }
            else if ( this.props.currentPage > page - 5 ) {
                paginate.push(
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( 1 ) }>1</button>
                    </li>
                );
                paginate.push(
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( 2 ) }>2</button>
                    </li>
                );
                paginate.push(
                    <li className="page-item disabled">
                        <span className="page-link">...</span>
                    </li>
                );
                for(let i = page-5; i <= page; i++){
                    if ( this.props.currentPage === i ) {
                        paginate.push(
                            <li className="page-item active disabled" key={ "page" + i }>
                                <button type="button" className="page-link" disabled={true}>{ i }</button>
                            </li>
                        );
                    } else {
                        paginate.push(
                            <li className="page-item" key={ "page" + i }>
                                <button type="button" className="page-link"  onClick={ () => this.props.btnPaginate( i ) }>{ i }</button>
                            </li>
                        );
                    }
                }
            }
            else {
                paginate.push(
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( 1 ) }>1</button>
                    </li>
                );
                paginate.push(
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( 2 ) }>2</button>
                    </li>
                );
                paginate.push(
                    <li className="page-item disabled">
                        <span className="page-link">...</span>
                    </li>
                );
                for(let i = this.props.currentPage-2; i <= this.props.currentPage+2; i++){
                    if ( this.props.currentPage === i ) {
                        paginate.push(
                            <li className="page-item active disabled" key={ "page" + i }>
                                <button type="button" className="page-link" disabled={true}>{ i }</button>
                            </li>
                        );
                    } else {
                        paginate.push(
                            <li className="page-item" key={ "page" + i }>
                                <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( i ) }>{ i }</button>
                            </li>
                        );
                    }
                }
                paginate.push(
                    <li className="page-item disabled">
                        <span className="page-link">...</span>
                    </li>
                );
                paginate.push(
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( page-1 ) }>{page-1}</button>
                    </li>
                );
                paginate.push(
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( page ) }>{page}</button>
                    </li>
                );
            }
        }
        else {
            for(let i = 1; i <= page; i++){
                if ( this.props.currentPage === i ) {
                    paginate.push(
                        <li className="page-item active disabled" key={ "page" + i }>
                            <button type="button" className="page-link" disabled={true}>{ i }</button>
                        </li>
                    )
                } else {
                    paginate.push(
                        <li className="page-item" key={ "page" + i }>
                            <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( i ) }>{ i }</button>
                        </li>
                    )
                }
            }
        }
        return paginate;
    }

    loadRaquo = () => {
        if ( this.props.total % this.props.perPage ) {
            return (
                this.props.currentPage !== parseInt(( this.props.total / this.props.perPage ).toFixed(0)) + 1 ? (
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( this.props.currentPage + 1 ) }>&raquo;</button>
                    </li>
                ) : (
                    <li className="page-item disabled">
                        <button type="button" className="page-link">&raquo;</button>
                    </li>
                )
            )
        } else {
            return (
                this.props.currentPage !== parseInt(( this.props.total / this.props.perPage ).toFixed(0)) ? (
                    <li className="page-item">
                        <button type="button" className="page-link" onClick={ () => this.props.btnPaginate( this.props.currentPage + 1 ) }>&raquo;</button>
                    </li>
                ) : (
                    <li className="page-item disabled">
                        <button type="button" className="page-link">&raquo;</button>
                    </li>
                )
            )
        }
    }

    render() {
        return (
            <ul className="pagination pagination-sm float-right">
                {
                    this.props.currentPage !== 1 ? (
                        <li className="prev">
                            <button type="button" onClick={ () => this.props.btnPaginate( this.props.currentPage - 1 ) } className="page-link">&laquo;</button>
                        </li>
                    ) : (
                        <li className="page-item disabled">
                            <button type="button" className="page-link" disabled={true}>&laquo;</button>
                        </li>
                    )
                }
                { this.paginate() }
                {
                    this.loadRaquo()
                }
            </ul>
        );
    }
}

export default PaginateComponent;